import type { PullResponse, PushResponse, TableChanges } from '@worker/sync/types'
import { apiGet, apiPost } from '@/core/api/client'
import type { SyncTransport } from './syncEngine'

/**
 * The real transport, over HTTP to the Worker.
 *
 * Kept behind the SyncTransport interface so the tests can drive the sync
 * engine against the actual server logic in-process, with no network and no
 * second implementation of the protocol to drift out of step.
 */
export const httpTransport: SyncTransport = {
  push(body: { deviceId: string; changes: TableChanges }, token: string): Promise<PushResponse> {
    return apiPost<PushResponse>('/api/sync/push', body, { token })
  },

  pull(sinceSeq: number, deviceId: string, token: string): Promise<PullResponse> {
    const query = `?sinceSeq=${encodeURIComponent(sinceSeq)}&deviceId=${encodeURIComponent(deviceId)}`
    return apiGet<PullResponse>(`/api/sync/pull${query}`, { token })
  },
}
